export default __webpack_public_path__ + "static/media/materialXchange.5ba5f6ea.png";